import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'address'
})

export class AddressPipe implements PipeTransform {
    transform(obj) {
        const address = new AddressObj(JSON.parse(JSON.stringify(obj)));
        let html = address.addressLine1 + '<br>' + (address.addressLine2 ? this.titleCase(address.addressLine2) + '<br>' : '');
        html += this.titleCase(address.city) + ', ' + address.state + ' ' + address.zipCode;
        return html;
    }

    titleCase(string: string) {
        if (!string) {
            return '';
        } else {
            return string.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase() ));
        }
    }
}

class AddressObj {

    constructor(obj) {
        this.addressLine1 = obj.addressLine1;
        this.addressLine2 = obj.addressLine2;
        this.city = obj.city;
        this.countryName = obj.countryName;
        this.countyName = obj.countyName;
        this.state = obj.state;
        this.zipCode = obj.zipCode;
    }

    addressLine1: string;
    addressLine2?: string;
    city: string;
    countryName: string;
    countyName: string;
    state: string;
    zipCode: string;
}
